import { type UseLinkOptions, useLink } from 'vue-router';
import logger from '~/services/QLogger';

import useRouteManagerStore from '~/stores/routeManager';
import { isNonProd, isSSRHydration } from '~/utils/EnvUtils';

const setRouteSourceName = (source: string) => useRouteManagerStore().setSourceName(source);

function useQLink(props: UseLinkOptions & { source: string }, shouldThrow = true) {
  const link = useLink(props);

  const originalNavigate = link.navigate;

  if (!props.source && shouldThrow) {
    const msg = 'source not provided in useQLink';
    const err = new Error(`\nQRouter Exception :: ${msg}\n`);
    if (isNonProd()) {
      throw err;
    } else {
      logger.logOnSentry(['type: QRouter.exception', `message: ${msg}`], 'exception');
    }
  }

  link.navigate = (e: MouseEvent | undefined) => {
    setRouteSourceName(props.source ?? 'useQLink');
    if (isSSRHydration()) {
      window.location = props.to as string & Location;
    }

    return originalNavigate(e);
  };

  return link;
}

export default useQLink;
